import { Box } from '~/eds/src/components/Box/Box';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { MarkedText } from '~/eds/src/components/MarkedText/MarkedText';
import { Text } from '~/eds/src/components/Text/Text';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { FormSectionState } from '~/redux/selectors';

import { WorkflowQuestion as WorkflowQuestion_DEPRECATED } from './WorkflowQuestion';
import { WorkflowQuestion } from './WorkflowQuestion/WorkflowQuestion';

interface Props {
  isEditing: boolean;
  search: string;
  section: FormSectionState;
}

export const WorkflowFormSection = ({ isEditing, search, section }: Props) => {
  const isIntakeFormEDSComponents = useFlag(FlagType.IntakeFormEDSComponents);

  const fields = section.questions.map((q) => {
    if (isIntakeFormEDSComponents && isEditing) {
      return <WorkflowQuestion key={q} id={q} search={search} />;
    }
    return (
      <WorkflowQuestion_DEPRECATED
        key={q}
        id={q}
        isEditing={isEditing}
        search={search}
      />
    );
  });

  return (
    <Layout direction="column" id={section.name} spacing={2}>
      {section.description && (
        <Box pb={2}>
          <Text preset="description">
            <MarkedText search={search} text={section.description} />
          </Text>
        </Box>
      )}
      {fields}
    </Layout>
  );
};
